export default function makeSafe(fn, code) {
  const handleError = error => {
    if (code && code !== error.code) {
      throw error;
    }
    return undefined;
  };

  return function fnSafe() {
    try {
      // eslint-disable-next-line prefer-rest-params
      const returnValue = fn.apply(fn, arguments);
      return returnValue instanceof Promise ? returnValue.catch(handleError) : returnValue;
    } catch (error) {
      return handleError(error);
    }
  };
}
